/**
 * Contém variáveis de ambiente para mais fácil utilização
 */
export const Environment = {
  /**
   * Configura a mensagem que será exibida dentro dos campos de pesquisa
   */
  INPUT_DE_BUSCA: "Pesquisar...",
  /**
   * Configura o limite de registros a serem exibidos nas listagens
   */
  LIMITE_DE_LINHAS: 10,
  /**
   * Configura a mensagem que será exibida quando uma listagem estiver vazia
   */
  LISTAGEM_VAZIA: "Nenhum registro encontrado.",

  /**
   * Indica modo de `prod` no azure.
   */
  IS_PRODUCTION: SSPA_APP_ENV === "prod",
  /**
   * Indica modo de `dev` no azure.
   */
  IS_DEV: SSPA_APP_ENV === "dev",
  /**
   * Indica modo de `development` na máquina local.
   */
  IS_DEVELOPMENT: SSPA_APP_ENV === "development",
  /**
   * Indica modo de `hml` no azure.
   */
  IS_HOMOLOG: SSPA_APP_ENV === "hml",

  /**
   * Url usada para o redirecionamento ao login service
   */
  BASE_URL:
    SSPA_APP_ENV === "prod"
      ? "https://api.gvdasa.com.br/assinaturaeletronica"
      : SSPA_APP_ENV === "hml"
      ? "https://api-hml.gvdasa.com.br/assinaturaeletronica"
      : "https://api-dev.gvdasa.com.br/assinaturaeletronica",

  /**
   * Informa a url para a API
   */
  URL_API:
    SSPA_APP_ENV === "prod"
      ? "https://api.gvdasa.com.br/assinaturaeletronica/api/v1"
      : SSPA_APP_ENV === "hml"
      ? "https://api-hml.gvdasa.com.br/assinaturaeletronica/api/v1"
      : "https://api-dev.gvdasa.com.br/assinaturaeletronica/api/v1",

  /** Retorna true ou false se deve usar o origin debug nas requests */
  IS_USING_ORIGIN_DEBUG:
    SSPA_APP_ENV === "development" ||
    (window.location.href.includes("localhost") && SSPA_APP_ENV === "dev"),

  /**
   * Informada quando está na máquina local, para permitir interação com o gateway.
   */
  URL_ORIGIN_DEBUG: "https://area87gvcollege2-dev.conversao.gvdasa.com.br/",
};
